<template>
  <v-stepper-content :step="stepNbr" :isActive="stepNbr == 7 || stepNbr == 5">
    <v-alert
      v-if="timeLeft == 0 && step == 5"
      class="animated bounceIn"
      type="error"
    >{{$t('general.timerMessage')}}</v-alert>
    <v-sheet
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{$t('steps.board')}}</v-sheet>
    <v-card class="pa-4" outlined :class="{'test-mode' : $store.getters['game/test']}">
      <v-row
        align="center"
        v-if="$store.getters['company/clients'].length < 2 && $store.getters['company/suppliers'].length < 2"
      >
        <v-col cols="2" offset="1" align="center">
          <company-logo
            v-if="$store.getters['company/suppliers'].length > 0"
            :name="$store.getters['company/suppliers'][0].name"
            :logo="filesUrl + 'logo/' + $store.getters['company/suppliers'][0].companieSettings.logo"
          ></company-logo>
        </v-col>
        <v-col cols="2" align="center">
          <v-divider v-if="$store.getters['company/suppliers'].length > 0"></v-divider>
        </v-col>
        <v-col cols="2" align="center">
          <company-logo
            :name="$store.getters['company/name']"
            :logo="filesUrl + 'logo/' + $store.getters['company/companySettings'].logo"
          ></company-logo>
        </v-col>
        <v-col cols="2" align="center">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="2" align="center">
          <company-logo
            :name="$store.getters['company/clients'][0].name"
            :logo="filesUrl + 'logo/' + $store.getters['company/clients'][0].companieSettings.logo"
          ></company-logo>
        </v-col>
      </v-row>
      <v-row align="stretch">
        <v-col cols="4">
          <v-row class="fill-height" align-content="space-between">
            <v-col cols="12">
              <v-sheet
                class="text-center mb-1"
                color="primary"
                elevation="5"
                dark
              >{{ $store.getters['company/productionCompany'] ? $t('steps.productionBatch') : $t('steps.supplierOrders')}}</v-sheet>
              <v-card elevation="5">
                <v-card-text class="text-center">
                  <span
                    v-if="stepNbr === 3"
                  >{{$store.getters['company/productionCompany'] ? $t('board.cantProduce') : $t('board.cantOrder')}}</span>
                  <v-btn
                    v-if="stepNbr === 5"
                    :class="{'animated heartBeat infinite slow' : !$store.state.company.loading}"
                    color="primary"
                    @click="$store.dispatch('company/setStep', 6)"
                    :loading="$store.state.company.loading"
                  >{{$store.getters['company/productionCompany'] ? $t('steps.productionBatch') : $t('steps.supplierOrders')}}</v-btn>
                  <span v-if="stepNbr === 7" class="units">{{supplierOrders}}</span>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" v-if="$store.getters['company/productionCompany']">
              <v-sheet
                class="text-center mb-1"
                color="primary"
                elevation="5"
                dark
              >{{$t('steps.inProgressProduction')}}</v-sheet>
              <v-card elevation="5">
                <v-card-text class="text-center">
                  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on }">
                      <span style="cursor:pointer" v-on="on" class="units">{{inProgressCount}}</span>
                    </template>

                    <v-list>
                      <v-list-item v-for="(item, index) in inProgress" :key="index">
                        <v-list-item-title>{{item.qty}} ({{ $t('general.week') + ' ' + item.week }})</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-sheet
                class="text-center mb-1"
                color="primary"
                elevation="5"
                dark
              >{{ $store.getters['company/productionCompany'] ? $t('steps.productionShipments') : $t('steps.supplierShipments')}}</v-sheet>
              <v-card elevation="5">
                <v-card-text class="text-center">
                  <v-btn
                    v-if="stepNbr === 3"
                    color="primary"
                    :disabled="!shipmentReady || $store.state.company.loading"
                    :class="{'animated heartBeat infinite slow' : shipmentReady && !$store.state.company.loading}"
                    @click="receipts"
                    :loading="$store.state.company.loading"
                  >{{shipmentReady ? $t('suppliersShipments.getShipments') : $t('suppliersShipments.waitShipment')}}</v-btn>
                  <span v-else class="units">{{supplierShipments}}</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" align="center">
          <v-row>
            <template v-if="$store.state.company.data.assemblyMode">
              <stock
                v-for="supplier in $store.getters['company/data'].suppliers "
                :key="supplier.supplier._id + step"
                :init-stock="supplier.stock[supplier.stock.length - 1] ? supplier.stock[supplier.stock.length - 1] : 0"
                :stock="supplier.stock[supplier.stock.length - 1] ? supplier.stock[supplier.stock.length - 1] : 0"
                :title="supplier.supplier.name"
                :cols="Math.floor(12 / $store.getters['company/data'].suppliers.length)"
              />
            </template>
            <stock
              :init-stock="$store.getters['company/stock']"
              :assembly="$store.state.company.data.assemblyMode"
            ></stock>
          </v-row>
        </v-col>
        <v-col cols="4" align="center">
          <v-row class="fill-height" align-content="space-between">
            <v-col cols="12">
              <v-sheet
                class="text-center mb-1"
                color="primary"
                elevation="5"
                dark
              >{{$t('steps.clientOrder')}}</v-sheet>
              <v-card elevation="5">
                <v-card-text v-if="$store.getters['company/clients'].length == 1">
                  <span class="units">{{clientRequest}}</span>
                </v-card-text>
                <v-card-text v-else class="pb-1">
                  <template v-for="client in $store.getters['company/data'].clients">
                    <p v-if="client.requests.length" class="units-multi-client" :key="client._id">{{client.client.name}} : {{client.requests[client.requests.length - 1]}}</p>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-sheet
                class="text-center mb-1"
                color="primary"
                elevation="5"
                dark
              >{{$t('steps.clientShipment')}}</v-sheet>
              <v-card elevation="5">
                <v-card-text v-if="$store.getters['company/clients'].length == 1">
                  <span class="units">{{clientShipments}}</span>
                </v-card-text>
                <v-card-text v-else class="pb-1">
                  <template v-for="client in $store.getters['company/data'].clients">
                    <p v-if="client.deliveries.length" class="units-multi-client" :key="client._id">{{client.client.name}} : {{client.deliveries[client.deliveries.length - 1]}}</p>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-row v-if="step == 7">
      <v-col cols="12" align="center">
        <v-btn
          :disabled="!$store.getters['game/nextWeekReady'] || $store.state.company.loading"
          :class="{'animated heartBeat infinite slow' : $store.getters['game/nextWeekReady'] && !$store.state.company.loading}"
          color="primary"
          :loading="$store.state.company.loading"
          @click="$store.dispatch('company/startWeek')"
        >{{$store.getters['game/nextWeekReady'] ? $t('steps.startNewWeek') : $t('instructions.wait')}}</v-btn>
      </v-col>
    </v-row>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";
import CompanyLogo from "@/components/CompanyLogo";
import Stock from "@/components/Stock";

export default {
  name: "Board",

  components: {
    CompanyLogo,
    Stock
  },

  props: {
    stepNbr: Number,
    step: Number,
    timeLeft: Number
  },

  data: () => ({
    menu: false
  }),

  methods: {
    receipts() {
      if (this.$store.getters["company/productionCompany"]) {
        this.$store.dispatch("company/productionReceipts");
      } else {
        this.$store.dispatch("company/suppliersReceipts");
      }
    }
  },

  computed: {

    inProgress() {
      let inProgress = [];
      let length = this.$store.state.company.data.productionLeadTime;
      let start = 0;
      let lag = 0;
      if (this.step > 4) {
        lag = 1;
      }
      if (this.step > 6) {
        lag = 1;
        start = 1;
      }
      length = length - lag;
      if (
        this.$store.getters["company/productionCompany"] &&
        this.$store.state.company.data
      ) {
        for (let index = start; index < length + start; index++) {
          if (this.$store.getters["company/data"].value.orders[this.$store.getters["company/data"].value.orders.length - (index + 1)] != undefined) {
            inProgress.push({
              week:
                this.$store.getters["company/week"] +
                (length - index - 1 + lag + start),
              qty: this.$store.getters["company/data"].value.orders[
                this.$store.getters["company/data"].value.orders.length -
                  (index + 1)
              ]
            });
          } else {
            inProgress.push({
              week:
                this.$store.getters["company/week"] +
                (length - index - 1 + lag + start),
              qty: this.$store.state.company.data.firstProduction
            });
          }
        }
      }
      return inProgress;
    },

    inProgressCount() {
      return this.inProgress.reduce((prev, curr) => prev + curr.qty, 0);
    },

    supplierOrders() {
      return this.$store.getters["company/data"].value.orders[
        this.$store.getters["company/data"].value.orders.length - 1
      ];
    },

    supplierShipments() {
      return this.$store.getters["company/data"].value.receipts[
        this.$store.getters["company/data"].value.receipts.length - 1
      ];
    },

    clientShipments() {
      return this.$store.getters["company/data"].value.deliveries[
        this.$store.getters["company/data"].value.deliveries.length - 1
      ];
    },

    clientRequest() {
      return this.$store.getters["company/data"].value.requests[
        this.$store.getters["company/data"].value.requests.length - 1
      ];
    },

    shipmentReady() {
      if (this.$store.getters["company/productionCompany"]) {
        return true;
      } else {
        return (
          this.$store.state.company.data.shipmentGet >=
          this.$store.getters["company/data"].suppliers.length
        );
      }
    },

    nextWeekReady() {
      return this.$store.getters['game/nextWeekReady']
    },
    
    ...mapGetters("company", {
      filesUrl: "filesUrl"
    })
  },
  watch: {

    nextWeekReady (val) {
      if (val) {
        this.$store.commit('interfaceSettings/SET_notification', {success: true, message : this.$t('steps.youCanStartNewWeek')})
      }
    }

  }
};
</script>

<style>
.units {
  font-size: 25px;
  font-weight: 900;
}
.units-multi-client {
  font-size: 22px;
  font-weight: 900;
}
</style>